import React, { useEffect, useState } from 'react'
import st from './Bundle.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { localisationMaster } from 'Localisation/Localisation'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import { superAxiosRequest } from 'axiosApi'
import Pagination from 'components/UI/Pagination/Pagination'
import { useParams } from 'react-router-dom'
import { ReactComponent as TrueAnswer } from 'components/ContentBox/img/true.svg'
import { ReactComponent as WrongAnswer } from 'components/ContentBox/img/false.svg'
import { ReactComponent as DownIcon } from 'components/UI/icons/arrow-down-s-line.svg'
import { permissions } from 'settings/permissions'
import { checkPermList } from 'helpers'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import QuestionAudios from 'components/Modules/Ebook/Common/Exercise/types/QuestionAudios/QuestionAudios'
import Stores from 'Stores'
import VideoPlayer from 'components/ContentBox/Global/MediaPlayer/VideoPlayer'
import { observer } from 'mobx-react'
import swal from 'sweetalert'
import asideModalStore from 'Stores/asideModalStore'
import listingStore from 'Stores/listingStore'

const initPagination = {
  page: 1,
  limit: 10,
}

const Bundle = () => {
  const [data, setData] = useState(null)
  const [pagination, setPagination] = useState(initPagination)
  const [openIndexes, setOpenIndexes] = useState([])
  const { id: bundleId } = useParams()
  const count_items = data?._meta.count_items
  const questionTypes = Stores.stqt || []

  const truncateText = (text, maxLength) => {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + '...'
    }
    return text
  }

  const truncateHTMLText = (htmlText, maxLength = 40) => {
    const tempElement = document.createElement('div')
    tempElement.innerHTML = htmlText
    const text = tempElement.textContent || tempElement.innerText || ''

    return truncateText(text, maxLength)
  }
  const toggleOpen = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    )
  }

  const menu = [
    ...(checkPermList(permissions.view_widget_bundle)
      ? [
          {
            name: localisationMaster(
              'menuName_5',
              'online-schedule/clients-after-online',
            ),
            action: 'detail',
          },
        ]
      : []),
    ...(checkPermList(permissions.edit_placement_test_question_widget)
      ? [
          {
            name: localisationMaster('text_11', 'lessons/course'),
            action: 'edit_question_bundle',
          },
        ]
      : []),
    ...(checkPermList(permissions.edit_placement_test_question_widget)
      ? [
          {
            name: localisationMaster('text_13', 'lessons/course'),
            action: 'delete_question',
          },
        ]
      : []),
  ]

  const action = (action, bundle) => {
    switch (action) {
      case 'detail':
        break
      case 'edit_question_bundle':
        editQuestion(bundle)
        break
      case 'delete_question':
        deleteQuestion(bundle)
        break
      default:
        break
    }
  }

  const answersList = ({ question_data, question_type }) => {
    let answers = question_data
    if (question_type.includes('make_sentence')) {
      answers = [
        {
          is_correct: true,
          name: question_data.correct_answer.split('|').join(' '),
        },
      ]
    }
    if (question_type.includes('question_tag_variants')) {
      answers = question_data
        .map((item) => item.variants)
        .flat()
        .filter((item) => item.is_correct)
    }
    if (question_type.includes('text_field')) {
      answers = [{ name: question_data.correct_answer, is_correct: true }]
    }
    return (
      <div className={st.bundleBody__variantsBox}>
        {answers.map((item, index) =>
          item.is_correct ? (
            <div
              key={index}
              className={`${st.bundleBody__variantsUnit} ${st.true}`}
            >
              <div>{<TrueAnswer />}</div>
              <div>{item.name}</div>
            </div>
          ) : (
            <div
              key={index}
              className={`${st.bundleBody__variantsUnit} ${st.wrong}`}
            >
              <div>{<WrongAnswer />}</div>
              <div>{item.name}</div>
            </div>
          ),
        )}
      </div>
    )
  }

  const qBody = (item) => {
    const getSubtitle = () => {
      if (item.question_type === 'question_tag_variants') {
        const data = item.question_data.map((item) => {
          return {
            ...item,
            variants: item.variants.filter((variant) => variant.is_correct)[0],
          }
        })

        let text = item.question_text
        data.forEach((dataItem) => {
          text = text.replace(
            dataItem.tag,
            `<strong>[${dataItem.variants.name}]</strong>`,
          )
        })
        return (
          <div
            className={st.bundleBody__item}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )
      }
      return (
        <div
          className={st.bundleBody__item}
          dangerouslySetInnerHTML={{ __html: item.question_text }}
        />
      )
    }

    switch (item.question_type) {
      case 'audio_text_variants':
      case 'audio_text_field':
        return (
          <div className={st.bundleBody__mediaQuestion}>
            <div>{getSubtitle()}</div>
            <div className={st.bundleBody__audio}>
              <QuestionAudios items={[{ file: item.audio }]} />
            </div>
            <div className={st.bundleBody__questionBox}>
              {answersList(item)}
            </div>
          </div>
        )
      case 'image_text_variants':
      case 'image_text_field':
        return (
          <div className={st.bundleBody__mediaQuestion}>
            {getSubtitle()}
            <div className={st.bundleBody__questionBody}>
              <div className={st.bundleBody__mediaBox}>
                <img src={item.image} width='320px' alt='pic' />
              </div>

              <div className={st.bundleBody__questionBox}>
                {answersList(item)}
              </div>
            </div>
          </div>
        )
      case 'video_text_variants':
      case 'video_text_field':
        return (
          <div className={st.bundleBody__mediaQuestion}>
            {getSubtitle()}
            <div className={st.bundleBody__questionBody}>
              <div className={st.bundleBody__mediaBoxVideo}>
                <VideoPlayer v_link={Stores.baseLink() + item.video} />
              </div>

              <div className={st.bundleBody__questionBox}>
                {answersList(item)}
              </div>
            </div>
          </div>
        )
      case 'question_text_variants':
      case 'question_text_field':
      case 'make_sentence':
      case 'question_tag_variants':
        return (
          <div>
            <div style={{ marginBottom: '20px' }}>{getSubtitle()}</div>
            <div>{answersList(item)}</div>
          </div>
        )
      default:
        return null
    }
  }

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'placement_test/questions',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        bundle: bundleId,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setData(data)
    })
  }, [pagination])

  const addNewQuestion = () => {
    let ms, md
    ms = {
      name: 'addQuestionsPlacementTest',
      link: 'placement_test/questions',
      button: localisationMaster(
        'button-two',
        'groups/categories',
        'add_category',
      ),
      title: 'Добавление нового вопроса',
      type: 'addQuestionsPlacementTest',
      data: 'json',
      isResponsive: true,
      onSubmitSuccess: listingStore.updateData,
      getMatchId: 'bundle',
      valid: {
        question_text: 'required',
        question_type: 'required',
      },
    }
    md = {
      bundle: bundleId,
      right_answer_scores: 1,
    }
    asideModalStore.activity(ms, md)
  }
  const editQuestion = (question) => {
    const ms = {
      name: 'addQuestionsPlacementTest',
      link: `placement_test/questions/${question.id}`,
      button: 'Редактировать',
      title: 'Редактирование вопроса',
      type: 'addQuestionsPlacementTest',
      data: 'json',
      getMatchId: 'bundle',
      isResponsive: true,
      is_put: true,
      valid: {
        question_text: 'required',
        question_type: 'required',
      },
    }

    const md = {
      ...question,
      bundle: bundleId,
      right_answer_scores: question.right_answer_scores || 1,
    }
    asideModalStore.activity(ms, md)
  }

  const deleteQuestion = (question) => {
    swal({
      title: localisationMaster('text_2', 'alert'),
      text: `Вы уверены, что хотите удалить этот вопрос?`,
      icon: 'warning',
      buttons: [
        localisationMaster('button_2', 'alert'),
        localisationMaster('button_1', 'alert'),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        superAxiosRequest({
          method: 'delete',
          link: `placement_test/questions/${question.id}`, // Ссылка для удаления вопроса
        })
          .then(() => {
            setData((prevData) => ({
              ...prevData,
              result: prevData.result.filter((item) => item.id !== question.id), // Удаление вопроса из состояния
            }))
            swal('Вопрос был успешно удалён!', {
              icon: 'success',
            })
          })
          .catch(() => {
            swal('Произошла ошибка при удалении вопроса.')
          })
      }
    })
  }

  return (
    <div className={st.container}>
      <div className={st.bundleHeader}>
        <PageHeader title={'Вопросы к связке'}>
          <HeaderAddButton
            title={localisationMaster(
              'button-two',
              'groups/categories',
              'add_category',
            )}
            onClick={addNewQuestion}
          />
        </PageHeader>
      </div>
      <div className={st.bundleBody}>
        <div className={st.bundleBody__header}>Записей: {count_items}</div>
        {data?.result.map((bundle, index) => {
          const isOpen = openIndexes.includes(index)
          const correctAnswer = Array.isArray(bundle.question_data)
            ? bundle.question_data.filter((item) => item.is_correct).length
            : 0
          const questionTypeName =
            questionTypes.find((q) => q.value === bundle.question_type)?.name ||
            'Неизвестный тип'
          return (
            <div key={bundle.id}>
              <div
                className={`${st.bundleBody__questionText} ${!isOpen ? st.bundleBody__questionTextClose : st.bundleBody__questionTextOpen}`}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: truncateHTMLText(bundle.question_text),
                  }}
                />
                <div className={st.bundleBody__action}>
                  <span>{questionTypeName}</span>
                  <span>
                    {localisationMaster('text_19', 'study/study-test')}:{' '}
                    {correctAnswer}
                  </span>
                  <div
                    className={isOpen ? st.detailInvolved : st.detail}
                    onClick={() => toggleOpen(index)}
                  >
                    <DownIcon
                      style={{ transform: isOpen ? 'rotate(180deg)' : 'none' }}
                    />
                  </div>
                  <ActionMenu
                    menu={menu}
                    action={(actionName) => action(actionName, bundle)}
                  />
                </div>
              </div>
              {isOpen && <div>{qBody(bundle)}</div>}
            </div>
          )
        })}
      </div>
      {count_items > 10 && (
        <Pagination
          limit={pagination.limit}
          count={count_items}
          page={pagination.page}
          onChange={(page) => setPagination({ ...pagination, page })}
          onChangePerPage={(limit) => {
            setPagination({ page: 1, limit })
          }}
        />
      )}
    </div>
  )
}

export default observer(Bundle)
